













import { Component, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import SelectOption from '@/types/form/SelectOption';

@Component({
  components: { Translation },
})
export default class Select extends Vue {
  @Prop([String, Number])
  public value!: string | number;

  @Prop(String)
  public identifier!: string;

  @Prop(Array)
  public options!: SelectOption[];
}
